<template>
    <div class="report-container">
      <h1>Buyers Report</h1>
  
      <!-- Filters -->
      <div class="filters">
        <label>Start Date:
          <input type="date" v-model="startDate" class="search-input" />
        </label>
        <label>End Date:
          <input type="date" v-model="endDate" class="search-input" />
        </label>
        <button @click="fetchReport" class="fetch-button">Generate Report</button>
      </div>
  
      <!-- Report Table -->
      <div class="table-container">
        <table class="report-table">
          <thead>
            <tr>
              <th class="left-align">Buyer Name</th>
              <th class="left-align">Email</th>
              <th class="right-align">Total Orders</th>
              <th class="right-align">Total Spent</th>              
            </tr>
          </thead>
          <tbody>
            <tr v-for="buyer in reportData.buyers" :key="buyer.buyer_email">
              <td class="left-align">{{ buyer.buyer_name || 'Unknown' }}</td>
              <td class="left-align">{{ buyer.buyer_email || 'N/A' }}</td>
              <td class="right-align">{{ formatNumber(buyer.total_orders) }}</td>
              <td class="right-align">${{ formatNumber(buyer.total_sales) }}</td>              
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  import api from '@/services/api';
  
  export default {
    data() {
      return {
        startDate: '',
        endDate: '',
        reportData: { buyers: [] }
      };
    },
    methods: {
      async fetchReport() {
        try {
          const response = await api.get('/reports/buyers', {
            params: { start_date: this.startDate, end_date: this.endDate }
          });
          this.reportData = response.data;
        } catch (error) {
          console.error('Error fetching Buyers Report:', error);
        }
      },
      formatNumber(value) {
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      
    }
  };
  </script>
  
  <style scoped>
  .report-container {
    padding: 20px;
    font-family: "Poppins", sans-serif !important;
    background: #9cd0f2;
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 800px;
    margin: 50px auto;
    text-align: center;
  }
  
  .filters {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .search-input {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #b0c4de;
    background: #e6eef3;
  }
  
  .fetch-button {
    padding: 8px 12px;
    background-color: #288671;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  
  .fetch-button:hover {
    background-color: #237a4b;
  }
  
  .table-container {
    background: #eef4fb;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .report-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  
  .report-table th, .report-table td {
    border: 1px solid #83a7cb;
    padding: 10px;
  }
  
  .report-table th {
    background: #e6eef3;
    text-align: left;
  }
  
  .report-table tr:hover {
    background-color: #e0f2f1;
  }
  
  .left-align {
    text-align: left;
  }
  
  .right-align {
    text-align: right;
  }
  </style>
  